import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';

import { HeaderDropdown } from '~components/Headers/HeaderCommon/HeaderDropdown/HeaderDropdown';

import styles from './HeaderNavItem.module.scss';
import type { HeaderNavItemProps } from './HeaderNavItem.types';

export function HeaderNavItem(props: HeaderNavItemProps) {
  if (props.type == 'link') {
    const TagName = props.tagName || 'a';
    return (
      <TagName
        href={props.href}
        className={styles.link}
        target={props.target}
        rel={
          props.rel || (props.target === '_blank' ? 'noreferrer' : undefined)
        }
        data-testid="header-link"
      >
        <Typography
          tagName={TypographySizes.p}
          mods={[TypographyMods.captionM]}
          className={classNames(props.className, styles.linkDesk)}
        >
          {props.title}
        </Typography>
        <Typography
          tagName={TypographySizes.p}
          mods={[TypographyMods.bodyL]}
          className={classNames(props.className, styles.linkMobile)}
        >
          {props.title}
        </Typography>
      </TagName>
    );
  }

  if (props.type === 'menu') {
    return <HeaderDropdown {...props} />;
  }

  return null;
}
